/*
 * MnZ KI-Stilprodukte (P1): Buybox im KI-Modus.
 * <mnz-ki-buybox> erweitert <mnz-buybox> (assets/mnz-buybox.js, muss vorher laden): Optionen, Preise, Upload und
 * Kauf-Button kommen unverändert aus der Standard-Buybox. Neu: KI-Generierung (Worker mnz-ki oder Testmodus "mock"),
 * Vorschau mit Vorher/Nachher, Verlauf, Kontingent, Fehlertexte.
 * P1 R7: Nach dem Upload (und bei "Neues Bild erstellen") öffnet sich der Foto-Editor der Standard-PDP (assets/mnz-editor.js,
 * Rahmen 4:5 bzw. 5:4 wie das KI-Bild). Keine automatische Erstellung mehr: erst der Button "Mein … erstellen" startet,
 * und zwar mit dem Ausschnitt (Cloudinary-URL a_/c_crop im eigenen Konto, wie die Druck-URL der Standard-PDP).
 * Warenkorb erst mit gewähltem KI-Bild. Eigenschaften: sichtbar Status, Stil, Format; versteckt _Print-URL (KI-Bild bzw.
 * Druckdatei), _Foto-Original (Original, nicht der Ausschnitt), _KI-Job, _KI-Ausschnitt (Rohdaten des Ausschnitts).
 * Der Browser schickt nur Stil-ID, Bild-URL (Ausschnitt), Ausrichtung und Turnstile-Token. Prompts kennt nur der Worker.
 */
(function (root) {
  'use strict';

  var K = {};

  K.STORE_VISIT = 'mnz-ki-visit';
  K.STORE_QUOTA = 'mnz-ki-quota';
  K.STORE_MOCK_USED = 'mnz-ki-mock-used';

  // Worker-Fehlercode -> Text-Schlüssel (Section-Einstellungen)
  K.errorKey = function (code) {
    switch (code) {
      case 'content_filter': return 'errFilter';
      case 'timeout': return 'errTimeout';
      case 'visit_limit': return 'errLimit';
      case 'ip_limit': return 'errDayLimit';
      case 'budget':
      case 'daily_images': return 'errBusy';
      case 'month_budget': return 'errBusyMonth';
      case 'turnstile':
      case 'missing_visit': return 'errCheck';
      default: return 'errGeneric';
    }
  };

  // Nochmal versuchen sinnvoll? Nicht bei Filter, Limits, Tages-/Monatsdeckel oder Sicherheitsprüfung.
  K.isRetryable = function (code) {
    return ['content_filter', 'visit_limit', 'ip_limit', 'turnstile', 'missing_visit', 'invalid_image', 'invalid_style',
      'budget', 'daily_images', 'month_budget', 'unavailable'].indexOf(code) === -1;
  };

  // Welcher Client? Testmodus nur mit Adresse "mock" UND erlaubt (Liquid: Theme nicht veröffentlicht oder Theme-Editor).
  // Leere oder ungültige Adresse = keiner (die Buybox zeigt dann ohnehin einen Hinweis statt Kauf-Button).
  K.clientMode = function (endpoint, mockAllowed) {
    var ep = String(endpoint || '').trim();
    if (ep === 'mock') return mockAllowed === true ? 'mock' : null;
    return /^https:\/\/[^\s/]+/.test(ep) ? 'http' : null;
  };

  // Turnstile-Token mit Zeitlimit: hängt das Widget, kommt nach timeoutMs ein leerer Token (Worker lehnt ab = Hinweis Sicherheitsprüfung)
  K.withTimeout = function (promise, timeoutMs, fallback) {
    return new Promise(function (resolve) {
      var done = false;
      var t = setTimeout(function () { if (!done) { done = true; resolve(fallback); } }, timeoutMs);
      promise.then(function (v) { if (!done) { done = true; clearTimeout(t); resolve(v); } },
        function () { if (!done) { done = true; clearTimeout(t); resolve(fallback); } });
    });
  };

  // Fehler, nach denen der Worker das Kontingent zurückbucht (alles außer Limit-/Prüffehlern vor dem Start)
  K.refundsQuota = function (code) {
    return ['timeout', 'content_filter', 'provider_error', 'storage_error', 'provider_unavailable', 'network'].indexOf(code) !== -1;
  };

  K.fill = function (tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? String(map[k]) : m;
    });
  };

  // Transformation hinter die vorhandenen Transformationen setzen (direkt vor /v123/), wie snippets/mnz-cart-thumb.liquid
  K.appendTransform = function (url, tf) {
    var u = String(url || '');
    var i = u.indexOf('/image/upload/');
    if (i < 0) return u;
    var head = u.slice(0, i + 14);
    var rest = u.slice(i + 14);
    var m = rest.match(/(^|\/)v\d+\//);
    if (m) {
      var at = m.index + (m[1] ? 1 : 0);
      return head + rest.slice(0, at) + tf + '/' + rest.slice(at);
    }
    return head + tf + '/' + rest;
  };

  K.thumb = function (url, w) {
    return K.appendTransform(url, 'c_limit,w_' + (w || 160) + ',h_' + (w || 160) + ',f_auto,q_auto');
  };

  // Ergebnisbild in der Buybox. Die Farbvorschau lädt genau diese URL (gleiche, schon erzeugte Transformation, Browser-Cache)
  K.resultSrc = function (url) {
    return K.appendTransform(url, 'w_900,f_auto,q_auto');
  };

  // Testmodus: "KI-Bild" = Kundenfoto im Format mit Cloudinary-Effekt e_cartoonify (bleibt auf res.cloudinary.com/schnaud).
  // R7: hinter vorhandene Transformationen (Ausschnitt a_/c_crop zuerst, dann Format und Effekt)
  K.mockResultUrl = function (photoUrl, orientation) {
    var ar = orientation === 'landscape' ? '5:4' : '4:5';
    return K.appendTransform(photoUrl, 'c_fill,ar_' + ar + ',g_auto/e_cartoonify');
  };

  /*
   * P1 R7: Eingabe für die KI = Ausschnitt. EC = MnzEditorCore, photo {url, width, height, publicId} (Maße wie im Editor,
   * also nach EXIF-Drehung), view = Editor-Ansicht (null = Standard: mittig, ganz ausgefüllt), aspect = Rahmen 0.8/1.25.
   * URL wie die Druck-URL der Standard-PDP (EC.cropUrl). Ohne Maße (Verlauf aus älteren Besuchen) bleibt es beim Original.
   */
  K.cropInput = function (EC, photo, view, aspect) {
    if (!photo || !photo.url) return null;
    if (!EC || !(photo.width > 0) || !(photo.height > 0)) return { url: photo.url, crop: null, view: null, photo: null };
    var v = EC.normView(view || EC.defaultView(), photo.width, photo.height, aspect);
    var c = EC.cropInt(EC.cropRect(photo.width, photo.height, v, aspect));
    return {
      url: EC.cropUrl(photo.url, c),
      crop: EC.cropData(c, photo),
      view: { rot: v.rot, zoom: v.zoom, cx: v.cx, cy: v.cy },
      photo: { url: photo.url, width: photo.width, height: photo.height, publicId: photo.publicId || '' }
    };
  };

  // Rahmen des Editors: immer das Format des KI-Bildes (4:5 bzw. 5:4), unabhängig von der Größe
  K.frameAspect = function (format) {
    return format === 'landscape' ? 1.25 : 0.8;
  };

  K.newId = function (prefix, bytes) {
    var arr = new Uint8Array(bytes || 12);
    var c = root.crypto;
    if (c && c.getRandomValues) c.getRandomValues(arr);
    else for (var i = 0; i < arr.length; i++) arr[i] = Math.floor(Math.random() * 256);
    var s = prefix || '';
    for (var j = 0; j < arr.length; j++) s += ('0' + arr[j].toString(16)).slice(-2);
    return s;
  };

  K.storage = function (st) {
    return {
      get: function (k) {
        try { var v = st.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; }
      },
      set: function (k, v) {
        try { st.setItem(k, JSON.stringify(v)); } catch (e) { /* privat-Modus: ohne Verlauf */ }
      }
    };
  };

  K.visitId = function (store) {
    var v = store.get(K.STORE_VISIT);
    if (typeof v !== 'string' || !/^[A-Za-z0-9_-]{8,64}$/.test(v)) {
      v = K.newId('v', 12);
      store.set(K.STORE_VISIT, v);
    }
    return v;
  };

  function codeError(code, status) {
    var e = new Error(code);
    e.code = code;
    e.status = status || 0;
    return e;
  }

  /*
   * HTTP-Client für den Worker. fetchFn/sleep injizierbar (Harness).
   * generate(body) -> {jobId, pollAfterMs, quota?}; status(jobId) -> Worker-Antwort
   */
  K.httpClient = function (endpoint, visitId, fetchFn) {
    var base = String(endpoint || '').replace(/\/+$/, '');
    var f = fetchFn || (root.fetch ? root.fetch.bind(root) : null);
    function call(path, init) {
      return f(base + path, init).then(function (res) {
        return res.text().then(function (t) {
          var data = null;
          try { data = t ? JSON.parse(t) : null; } catch (e) { data = null; }
          if (!res.ok) throw codeError(data && data.error && data.error.code ? data.error.code : 'provider_unavailable', res.status);
          return data || {};
        });
      }, function () {
        throw codeError('network');
      });
    }
    return {
      mode: 'http',
      generate: function (body) {
        return call('/generate', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-MnZ-Visit': visitId },
          body: JSON.stringify(body)
        });
      },
      status: function (jobId) {
        return call('/status/' + encodeURIComponent(jobId), { method: 'GET', headers: { 'X-MnZ-Visit': visitId } });
      }
    };
  };

  /*
   * Testmodus ohne Worker: gleiches Protokoll, Zeit über now(). Fehlerfälle per opts.scenario
   * (filter | timeout | error | limit | busy), Kontingent wie der Worker je Besuch (sessionStorage).
   */
  K.mockClient = function (opts) {
    var store = opts.store;
    var limit = opts.limit;
    var now = opts.now || function () { return Date.now(); };
    var jobs = {};
    return {
      mode: 'mock',
      generate: function (body) {
        return new Promise(function (resolve, reject) {
          setTimeout(function () {
            var sc = opts.scenario || '';
            if (sc === 'busy') return reject(codeError('budget', 503));
            var used = store.get(K.STORE_MOCK_USED) || 0;
            if (sc === 'limit' || used >= limit) return reject(codeError('visit_limit', 429));
            used += 1;
            store.set(K.STORE_MOCK_USED, used);
            var id = K.newId('mock-', 8);
            jobs[id] = { until: now() + opts.delayMs, body: body, scenario: sc };
            resolve({ jobId: id, status: 'running', pollAfterMs: 1000, quota: { limit: limit, remaining: Math.max(0, limit - used) } });
          }, 150);
        });
      },
      status: function (jobId) {
        var j = jobs[jobId];
        if (!j) return Promise.reject(codeError('not_found', 404));
        if (now() < j.until) return Promise.resolve({ jobId: jobId, status: 'running', print: { status: 'off' } });
        var fail = { filter: 'content_filter', timeout: 'timeout', error: 'provider_error' }[j.scenario];
        if (fail) {
          // Worker bucht Fehler zurück
          var used = store.get(K.STORE_MOCK_USED) || 0;
          store.set(K.STORE_MOCK_USED, Math.max(0, used - 1));
          return Promise.resolve({ jobId: jobId, status: 'failed', error: { code: fail }, print: { status: 'off' } });
        }
        return Promise.resolve({ jobId: jobId, status: 'done', previewUrl: K.mockResultUrl(j.body.imageUrl, j.body.orientation), print: { status: 'off' } });
      }
    };
  };

  /*
   * Ein Job von Start bis Ergebnis. Ergebnis {ok:true, jobId, previewUrl, printUrl, printPending, quota}
   * oder {ok:false, code, quota, started}. o: {timeoutMs, now, sleep, isCancelled, onStarted}
   */
  K.runJob = function (client, body, o) {
    var now = o.now || function () { return Date.now(); };
    var sleep = o.sleep || function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
    var t0 = now();
    var quota = null;
    var netErrors = 0;
    return client.generate(body).then(function (g) {
      quota = g.quota || null;
      if (o.onStarted) o.onStarted(g);
      var wait = Math.max(500, Math.min(5000, g.pollAfterMs || 3000));
      var loop = function () {
        if (o.isCancelled && o.isCancelled()) return { ok: false, code: 'cancelled', quota: quota, started: true };
        if (now() - t0 > o.timeoutMs) return { ok: false, code: 'timeout', quota: quota, started: true, local: true };
        return sleep(wait).then(function () {
          if (o.isCancelled && o.isCancelled()) return { ok: false, code: 'cancelled', quota: quota, started: true };
          return client.status(g.jobId).then(function (st) {
            netErrors = 0;
            if (st.status === 'done' && st.previewUrl) {
              var p = st.print || {};
              return {
                ok: true,
                jobId: g.jobId,
                previewUrl: st.previewUrl,
                printUrl: p.status === 'done' && p.url ? p.url : '',
                printPending: p.status === 'pending' || p.status === 'running',
                quota: quota
              };
            }
            if (st.status === 'failed') return { ok: false, code: (st.error && st.error.code) || 'provider_error', quota: quota, started: true };
            wait = 2000;
            return loop();
          }, function (err) {
            // Kurze Netzaussetzer beim Abfragen: weiter versuchen, der Job läuft im Worker weiter
            if (++netErrors > 4) return { ok: false, code: (err && err.code) || 'network', quota: quota, started: true };
            wait = 3000;
            return loop();
          });
        });
      };
      return loop();
    }, function (err) {
      return { ok: false, code: (err && err.code) || 'network', quota: quota, started: false };
    });
  };

  root.MnzKiCore = K;

  /* =====================================================================
   * DOM-Schicht
   * ===================================================================== */
  if (typeof window === 'undefined' || !window.customElements) return;

  function define() {
    if (window.customElements.get('mnz-ki-buybox')) return;
    var Base = window.customElements.get('mnz-buybox');
    var Core = window.MnzCore;
    if (!Base || !Core) return;

    function setProp(input, value) {
      if (!input) return;
      input.value = value;
      input.disabled = !value;
    }

    /*
     * P1 R5: Farbvorschau des gewählten KI-Bildes. Nutzt die Popup-Logik der Standard-PDP (MnzEditor.prototype aus
     * assets/mnz-editor.js: Tabs je Farbanzahl, k-means im Web Worker, Cache, Vorrechnen, Farben-Akkordeon, Übernehmen).
     * Eingabe ist statt des Foto-Ausschnitts das KI-Bild in derselben URL wie in der Buybox (K.resultSrc): kein KI-Aufruf,
     * keine neue Cloudinary-Transformation. Neues Bild gewählt = neuer token, alte Rechnungen gelten als veraltet.
     * o: {lock(bool), colors(), selectedColor(), chooseColor(value), strings}
     */
    function KiPreview(el, btn, o) {
      var EC = window.MnzEditorCore;
      var self = this;
      this.o = o;
      this.s = o.strings || {};
      this.btn = btn;
      this.aspect = 0.8;
      this.work = null; // Editor-Logik prüft nur "Bild da"
      this.token = 0;
      this.cache = new Map();
      this._pending = {};
      this._qid = 0;
      this._queue = Promise.resolve();
      this.result = null;
      this.view = 'paint';
      this.pv = {
        el: el,
        tabs: el.querySelector('[data-mnz-preview-tabs]'),
        panel: el.querySelector('[data-mnz-preview-panel]'),
        stage: el.querySelector('[data-mnz-preview-stage]'),
        canvas: el.querySelector('[data-mnz-preview-canvas]'),
        busy: el.querySelector('[data-mnz-preview-busy]'),
        failed: el.querySelector('[data-mnz-preview-failed]'),
        choose: el.querySelector('[data-mnz-preview-choose]'),
        colors: el.querySelector('[data-mnz-preview-colors]'),
        img: el.querySelector('[data-mnz-ki-preview-img]'),
        paintBtn: el.querySelector('[data-mnz-ki-preview-paint]'),
        value: null
      };
      this.preview = new EC.Dialog(el, {
        lock: o.lock,
        focus: function () { return self.pv.tabs.querySelector('[aria-selected="true"]'); },
        onClose: function () { self.pv.value = null; }
      });
      this._placeColors();

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.openPreview(btn);
      });
      this.pv.tabs.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[role="tab"]') : null;
        if (t) self._selectTab(t.getAttribute('data-value'), false);
      });
      this.pv.tabs.addEventListener('keydown', function (e) {
        var list = Array.prototype.slice.call(self.pv.tabs.querySelectorAll('[role="tab"]'));
        var i = list.indexOf(document.activeElement);
        if (i < 0) return;
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = list[(i + 1) % list.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = list[(i - 1 + list.length) % list.length];
        else if (e.key === 'Home') next = list[0];
        else if (e.key === 'End') next = list[list.length - 1];
        if (!next) return;
        e.preventDefault();
        self._selectTab(next.getAttribute('data-value'), true);
      });
      this.pv.choose.addEventListener('click', function (e) {
        e.preventDefault();
        var value = self.pv.value;
        if (value && self.o.chooseColor) self.o.chooseColor(value);
        self.preview.close();
      });
      var views = el.querySelectorAll('[data-mnz-ki-preview-view]');
      for (var v = 0; v < views.length; v++) {
        views[v].addEventListener('click', function (e) {
          e.preventDefault();
          self._setView(this.getAttribute('data-mnz-ki-preview-view'));
        });
      }
    }

    // Methoden der Standard-Farbvorschau übernehmen (eine Quelle, gleiche Rechnung und Darstellung)
    function borrowPreview() {
      var P = window.MnzEditor.prototype;
      ['openPreview', '_buildTabs', '_showPreview', '_prefetch', '_paintPreview', '_paintColors', '_placeColors',
        '_quantizeNow', '_runMain', '_worker', '_killWorker'].forEach(function (m) { KiPreview.prototype[m] = P[m]; });
      var baseSelect = P._selectTab;
      var baseQuantize = P._quantize;

      KiPreview.prototype._selectTab = function (value, focus) {
        baseSelect.call(this, value, focus);
        if (this.pv.paintBtn) this.pv.paintBtn.textContent = K.fill(this.s.previewPaint, { farben: value });
        this._setView(this.view);
      };

      // Nur Bild und Farbanzahl bestimmen das Ergebnis (kein Ausschnitt, keine Drehung)
      KiPreview.prototype._previewKey = function (n) {
        return [this.result ? this.result.id : '', n].join('|');
      };

      // Erst das KI-Bild laden (einmal je Bild), dann wie die Standard-Vorschau rechnen
      KiPreview.prototype._quantize = function (n, key) {
        var self = this;
        var token = this.token;
        return this._load().then(function () {
          if (token !== self.token) throw 'stale';
          return baseQuantize.call(self, n, key);
        });
      };

      KiPreview.prototype._quantInput = function () {
        var EC = window.MnzEditorCore;
        var src = this.work;
        var long = EC.PREVIEW_LONG;
        var ar = src.naturalWidth / src.naturalHeight;
        var w = ar >= 1 ? long : Math.max(1, Math.round(long * ar));
        var h = ar >= 1 ? Math.max(1, Math.round(long / ar)) : long;
        var c = document.createElement('canvas');
        c.width = w;
        c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(src, 0, 0, w, h);
        var img = ctx.getImageData(0, 0, w, h);
        c.width = 0;
        c.height = 0;
        return img;
      };
    }

    KiPreview.prototype._load = function () {
      var self = this;
      var token = this.token;
      if (this._loading && this._loadingToken === token) return this._loading;
      var url = this.result ? K.resultSrc(this.result.previewUrl) : '';
      this._loadingToken = token;
      this._loading = new Promise(function (resolve, reject) {
        if (!url) { reject('no_image'); return; }
        var img = new Image();
        img.crossOrigin = 'anonymous'; // Cloudinary liefert CORS, sonst wäre die Leinwand gesperrt
        img.decoding = 'async';
        img.onload = function () {
          if (token !== self.token) { reject('stale'); return; }
          self.work = img;
          self.aspect = img.naturalWidth / img.naturalHeight || self.aspect;
          self.pv.el.style.setProperty('--mnz-ar', String(self.aspect));
          resolve(img);
        };
        img.onerror = function () { reject(new Error('KI-Bild nicht ladbar')); };
        img.src = url;
      });
      // Fehlversuch nicht festhalten: nächstes Öffnen lädt neu
      this._loading.catch(function () { if (self._loadingToken === token) self._loading = null; });
      return this._loading;
    };

    // Gewähltes KI-Bild setzen (null = keins). Wechsel verwirft laufende Rechnungen zum alten Bild.
    KiPreview.prototype.setResult = function (r) {
      var id = r ? r.id : '';
      this.btn.hidden = !r;
      if ((this.result ? this.result.id : '') === id) return;
      this.result = r || null;
      this.token++;
      this.work = r ? true : null; // echtes Bild kommt mit _load()
      this._loading = null;
      this.aspect = r && r.orientation === 'landscape' ? 1.25 : 0.8;
      if (this.pv.img) this.pv.img.src = r ? K.resultSrc(r.previewUrl) : '';
      if (this.preview.isOpen()) this.preview.close();
    };

    KiPreview.prototype._setView = function (view) {
      this.view = view === 'image' ? 'image' : 'paint';
      var pv = this.pv;
      pv.stage.setAttribute('data-view', this.view);
      if (pv.img) pv.img.hidden = this.view !== 'image';
      var btns = pv.el.querySelectorAll('[data-mnz-ki-preview-view]');
      for (var i = 0; i < btns.length; i++) btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-mnz-ki-preview-view') === this.view ? 'true' : 'false');
    };

    KiPreview.prototype.destroy = function () {
      this.token++;
      this._killWorker();
    };

    class MnzKiBuybox extends Base {
      _setup() {
        var cfg = JSON.parse(this.querySelector('script[data-mnz-config]').textContent);
        this.ki = cfg.ki || {};
        this.ks = this.ki.strings || {};
        this.kiStore = K.storage(window.sessionStorage);
        this.kiKey = 'mnz-ki:' + (this.ki.styleId || '');
        var saved = this.kiStore.get(this.kiKey) || {};
        var limit = Math.max(0, parseInt(this.ki.visitLimit, 10) || 0);
        var q = this.kiStore.get(K.STORE_QUOTA);
        this.kiState = {
          phase: 'idle', // idle | generating | done | error
          results: Array.isArray(saved.results) ? saved.results.slice(-12) : [],
          selectedId: saved.selectedId || null,
          view: 'after',
          error: null,
          limit: q && typeof q.limit === 'number' ? q.limit : limit,
          remaining: q && typeof q.remaining === 'number' ? q.remaining : limit,
          formatTouched: false,
          crop: false, // R7: Ausschnitt wählen (Editor offen), erst der Button erstellt
          token: 0
        };
        this.kiState.waitTexts = (this.ki.waitTexts || []).map(function (t) { return String(t).trim(); }).filter(Boolean);
        super._setup();
        this._setupKi();
      }

      // P1 R7: Foto-Editor der Standard-PDP für den Ausschnitt vor der Erstellung (gedruckt wird weiter das KI-Bild)
      _setupEditor() {
        super._setupEditor();
      }

      _editorFrame() {
        var size = this.cfg.sizeIndex >= 0 ? this.state.sel.values[this.cfg.sizeIndex] : '';
        return { size: size, aspect: K.frameAspect(this.state.format) };
      }

      // Ausschnitt aus dem Editor (gleiches Foto), sonst Standard-Ausschnitt aus den Maßen, sonst das Original
      _kiInput() {
        var EC = window.MnzEditorCore;
        var photo = this.state.photo;
        var ed = this.editor;
        var aspect = this._editorFrame().aspect;
        if (ed && ed.photo && photo && ed.photo.url === photo.url && ed.W && ed.H) {
          return K.cropInput(EC, { url: photo.url, width: ed.W, height: ed.H, publicId: ed.photo.publicId || photo.publicId }, ed.view, aspect);
        }
        return K.cropInput(EC, photo, null, aspect);
      }

      // Ausschnitt wählen (nach "Neues Bild erstellen"): Editor mit dem aktuellen Foto, letzter Ausschnitt dazu bleibt
      _kiOpenCrop() {
        var st = this.kiState;
        var photo = this.state.photo;
        if (!photo || !photo.url || this.state.busy || st.phase === 'generating') return;
        if (st.remaining <= 0) {
          this._kiFail('visit_limit');
          return;
        }
        // Verlauf aus älteren Besuchen ohne Maße: wie bisher direkt erstellen
        if (!this.editor || !(photo.width > 0) || !(photo.height > 0)) {
          this._kiStart();
          return;
        }
        if (!this.editor.photo || this.editor.photo.url !== photo.url) {
          this.editor.setPhoto(photo, null);
          var r = this._kiFind(st.selectedId);
          if (r && r.original === photo.url && r.view) this.editor._setView(r.view);
        }
        st.crop = true;
        st.error = null;
        if (st.phase === 'error') st.phase = st.results.length ? 'done' : 'idle';
        this._render();
        var box = this.kiEl.crop;
        if (box && box.getBoundingClientRect && box.getBoundingClientRect().top < 0 && box.scrollIntoView) box.scrollIntoView({ block: 'start' });
      }

      _setupKi() {
        var self = this;
        var q = function (sel) { return self.querySelector(sel); };
        this.kiEl = {
          root: q('[data-mnz-ki]'),
          idle: q('[data-mnz-ki-idle]'),
          stage: q('[data-mnz-ki-stage]'),
          frame: q('[data-mnz-ki-frame]'),
          before: q('[data-mnz-ki-before]'),
          after: q('[data-mnz-ki-after]'),
          loader: q('[data-mnz-ki-loader]'),
          wait: q('[data-mnz-ki-wait]'),
          bar: q('[data-mnz-ki-bar]'),
          toggle: q('[data-mnz-ki-toggle]'),
          badge: q('[data-mnz-ki-badge]'),
          note: q('[data-mnz-ki-note]'),
          error: q('[data-mnz-ki-error]'),
          errorText: q('[data-mnz-ki-error-text]'),
          retry: q('[data-mnz-ki-retry]'),
          mismatch: q('[data-mnz-ki-mismatch]'),
          mismatchText: q('[data-mnz-ki-mismatch-text]'),
          history: q('[data-mnz-ki-history]'),
          historyList: q('[data-mnz-ki-history-list]'),
          actions: q('[data-mnz-ki-actions]'),
          newBtn: q('[data-mnz-ki-new]'),
          quota: q('[data-mnz-ki-quota]'),
          turnstile: q('[data-mnz-ki-turnstile]'),
          crop: q('[data-mnz-ki-crop]'),
          create: q('[data-mnz-ki-create]'),
          cropQuota: q('[data-mnz-ki-crop-quota]'),
          cropBack: q('[data-mnz-ki-crop-back]'),
          fmt: this.querySelectorAll('[data-mnz-ki-fmt]')
        };
        this.styleInput = this.form.querySelector('[data-mnz-prop-style]');
        this._setupKiPreview();
        this.jobInput = this.form.querySelector('[data-mnz-prop-job]');

        // Formatwahl des Kunden hat Vorrang vor der Automatik beim Upload
        this.addEventListener('change', function (e) {
          if (e.target && e.target.matches && e.target.matches('[data-mnz-format-input]')) {
            self.kiState.formatTouched = true;
            if (self.kiState.phase === 'generating') self.kiState.formatChangedWhileGen = true;
            self._kiAfterFormatChange();
          }
        });
        this.kiEl.newBtn.addEventListener('click', function (e) { e.preventDefault(); self._kiOpenCrop(); });
        if (this.kiEl.create) this.kiEl.create.addEventListener('click', function (e) { e.preventDefault(); self._kiStart(); });
        if (this.kiEl.cropBack) {
          this.kiEl.cropBack.addEventListener('click', function (e) {
            e.preventDefault();
            self.kiState.crop = false;
            self._kiSelect(self.kiState.selectedId);
          });
        }
        // Hoch/Quer direkt am Editor: wählt die Format-Kachel aus Schritt 1 (gleicher Ablauf wie dort)
        for (var fi = 0; fi < this.kiEl.fmt.length; fi++) {
          this.kiEl.fmt[fi].addEventListener('click', function (e) {
            e.preventDefault();
            var input = self.querySelector('[data-mnz-format-input][value="' + this.getAttribute('data-mnz-ki-fmt') + '"]');
            if (input && !input.checked) input.click();
          });
        }
        this.kiEl.retry.addEventListener('click', function (e) { e.preventDefault(); self._kiStart(); });
        var views = this.querySelectorAll('[data-mnz-ki-view]');
        for (var i = 0; i < views.length; i++) {
          views[i].addEventListener('click', function (e) {
            e.preventDefault();
            self.kiState.view = this.getAttribute('data-mnz-ki-view') === 'before' ? 'before' : 'after';
            self._renderKi();
          });
        }
        this.kiEl.historyList.addEventListener('click', function (e) {
          var b = e.target.closest ? e.target.closest('[data-mnz-ki-pick]') : null;
          if (!b) return;
          e.preventDefault();
          self._kiSelect(b.getAttribute('data-mnz-ki-pick'));
        });
        // Kauf-Button "Bild erstellen" (Foto da, aber kein Bild, z.B. nach einem Fehler)
        this.cta.addEventListener('click', function () {
          if (self._ctaMode() === 'generate') self._kiStart();
        });
        if (this._stickyBtn) {
          this._stickyBtn.addEventListener('click', function () {
            if (self._ctaMode() === 'generate') self._kiStart();
          });
        }

        // Verlauf aus diesem Besuch wiederherstellen (Seite neu geladen)
        var sel = this._kiFind(this.kiState.selectedId);
        if (sel) {
          this.state.format = sel.orientation;
          this.kiState.phase = 'done';
          this._kiRestorePhoto(sel);
        } else if (this.kiState.results.length) {
          this.kiState.phase = 'done';
        }
        this._render();
      }

      // Farbvorschau des KI-Bildes (nur mit Farben-Option und geladener Standard-Vorschau)
      _setupKiPreview() {
        var self = this;
        var el = this.querySelector('[data-mnz-ki-preview]');
        var btn = this.querySelector('[data-mnz-ki-preview-open]');
        if (!el || !btn || !window.MnzEditor || !window.MnzEditorCore || !window.MnzEditorCore.Dialog) return;
        try {
          if (!KiPreview.prototype.openPreview) borrowPreview();
          this.kiPreview = new KiPreview(el, btn, {
            strings: this.ks,
            lock: function (on) { self._lockScroll(on); },
            colors: function () { return self.model.baseColors.slice(); },
            selectedColor: function () { return self.model.colorsIndex >= 0 ? self.state.sel.values[self.model.colorsIndex] : null; },
            chooseColor: function (value) { self._chooseColor(value); }
          });
        } catch (err) {
          this.kiPreview = null; // Bestellung klappt auch ohne Vorschau
          btn.hidden = true;
          if (window.console) console.error('[MnZ KI] Farbvorschau', err);
        }
      }

      /* ---------- Hilfen ---------- */
      _kiFind(id) {
        var r = this.kiState.results;
        for (var i = 0; i < r.length; i++) if (r[i].id === id) return r[i];
        return null;
      }

      // Gewähltes Bild nur, wenn es zum aktuellen Format passt
      _kiSelected() {
        var r = this._kiFind(this.kiState.selectedId);
        return r && r.orientation === this.state.format ? r : null;
      }

      _kiSave() {
        this.kiStore.set(this.kiKey, { results: this.kiState.results.slice(-12), selectedId: this.kiState.selectedId });
        this.kiStore.set(K.STORE_QUOTA, { limit: this.kiState.limit, remaining: this.kiState.remaining });
      }

      _kiFormatLabel(f) {
        return f === 'landscape' ? this.s.formatLandscape : this.s.formatPortrait;
      }

      // Für die Bestellung: das Original des gewählten Bildes gilt als "Foto" der Standard-Buybox
      _kiRestorePhoto(r) {
        if (this.state.photo && this.state.photo.url === r.original) return;
        if (this.state.busy) return;
        // R7: Maße aus dem Verlauf, damit "Neues Bild erstellen" den Ausschnitt wieder öffnen kann
        var p = r.photo && r.photo.url === r.original ? r.photo : null;
        this._revokePreview(); // Upload-Vorschau eines anderen (neuen) Fotos nicht stehen lassen
        this.state.photo = { url: r.original, width: p ? p.width : 0, height: p ? p.height : 0, publicId: p ? (p.publicId || '') : '' };
        this.state.phase = 'done';
        this.state.remotePreview = K.thumb(r.original, 160);
      }

      _kiClient() {
        var ep = String(this.ki.endpoint || '').trim();
        var visit = K.visitId(this.kiStore);
        var mode = K.clientMode(ep, this.ki.mockAllowed);
        if (!mode) return null;
        if (mode === 'mock') {
          var params = new URLSearchParams(window.location.search);
          var d = parseFloat(params.get('mnz_ki_mock_delay'));
          return K.mockClient({
            store: this.kiStore,
            limit: this.kiState.limit,
            delayMs: (d > 0 ? d : (this.ki.mockDelaySec || 20)) * 1000,
            scenario: params.get('mnz_ki_mock') || ''
          });
        }
        return K.httpClient(ep, visit);
      }

      // Turnstile (Platzhalter bis zum Cloudflare-Konto): ohne Site-Key leerer Token
      _kiToken() {
        var key = String(this.ki.turnstileSitekey || '').trim();
        var box = this.kiEl.turnstile;
        if (!key || !box) return Promise.resolve('');
        var self = this;
        return K.withTimeout(loadTurnstile().then(function (ts) {
          return new Promise(function (resolve) {
            box.hidden = false;
            if (self._tsWidget !== undefined) {
              try { ts.reset(self._tsWidget); } catch (e) { /* neu rendern */ }
            }
            self._tsResolve = resolve;
            if (self._tsWidget === undefined) {
              self._tsWidget = ts.render(box, {
                sitekey: key,
                appearance: 'interaction-only',
                callback: function (t) { box.hidden = true; if (self._tsResolve) { self._tsResolve(t); self._tsResolve = null; } },
                'error-callback': function () { if (self._tsResolve) { self._tsResolve(''); self._tsResolve = null; } },
                'timeout-callback': function () { if (self._tsResolve) { self._tsResolve(''); self._tsResolve = null; } },
                'expired-callback': function () { try { ts.reset(self._tsWidget); } catch (e) { /* egal */ } }
              });
            }
          });
        }, function () { return ''; }), (this.ki.turnstileTimeoutSec || 30) * 1000, '').then(function (t) {
          if (!t) box.hidden = true;
          self._tsResolve = null;
          return t;
        });
      }

      /* ---------- Ablauf ---------- */
      _succeed(data) {
        super._succeed(data);
        // R7: nicht mehr automatisch erstellen. Mit Kontingent öffnet sich der Ausschnitt, der Button startet.
        // Ohne Kontingent: Hinweis, frühere Bilder bleiben wählbar
        if (this.kiState.remaining > 0) {
          this.kiState.crop = true;
          this._render();
        } else {
          // Kein Kontingent mehr: das neue Foto wird nicht umgewandelt. Bestellt wird weiter das gewählte Bild,
          // deshalb zeigt der Upload wieder dessen Foto (sonst glaubt man, das neue Foto zu bestellen).
          var sel = this._kiSelected();
          if (sel) {
            this.state.photo = { url: sel.original, width: 0, height: 0, publicId: '' };
            this.state.phase = 'done';
            this.state.remotePreview = K.thumb(sel.original, 160);
          }
          this._kiFail('visit_limit');
        }
      }

      _handleFile(file) {
        this.kiState.token++; // laufende Erstellung zum alten Foto nicht mehr anzeigen
        this.kiState.crop = false;
        if (this.kiState.phase === 'generating' || this.kiState.phase === 'error') this.kiState.phase = this.kiState.results.length ? 'done' : 'idle';
        this.kiState.error = null;
        this._kiStopLoader();
        super._handleFile(file);
      }

      _fail(key) {
        this.kiState.crop = false;
        super._fail(key);
        // Upload fehlgeschlagen: ein schon gewähltes Bild bleibt bestellbar
        var sel = this._kiSelected();
        if (sel) this.state.photo = { url: sel.original, width: 0, height: 0, publicId: '' };
        this._render();
      }

      _applyAutoFormat(w, h) {
        if (this.kiState && this.kiState.formatTouched) return;
        super._applyAutoFormat(w, h);
      }

      _kiStart() {
        var self = this;
        var st = this.kiState;
        var photo = this.state.photo;
        if (!photo || !photo.url || this.state.busy || st.phase === 'generating') return;
        if (st.remaining <= 0) {
          st.crop = false;
          this._kiFail('visit_limit');
          return;
        }
        var token = ++st.token;
        var orientation = this.state.format;
        var original = photo.url;
        var input = this._kiInput(); // R7: Ausschnitt (oder Original ohne Maße)
        st.crop = false;
        st.genInput = input.url;
        st.phase = 'generating';
        st.error = null;
        st.view = 'after';
        st.genFormat = orientation;
        this._kiStartLoader();
        this._render();

        var client = this._kiClient();
        if (!client) {
          st.phase = st.results.length ? 'done' : 'idle';
          this._kiStopLoader();
          this._kiFail('unavailable');
          return;
        }
        st.formatChangedWhileGen = false;
        this._kiToken().then(function (tsToken) {
          if (token !== st.token) return null;
          return K.runJob(client, {
            styleId: self.ki.styleId,
            imageUrl: input.url,
            orientation: orientation,
            turnstileToken: tsToken
          }, {
            timeoutMs: (self.ki.timeoutSec || 110) * 1000,
            isCancelled: function () { return token !== st.token || !self.isConnected; },
            onStarted: function (g) {
              if (g.quota) self._kiQuota(g.quota);
              else st.remaining = Math.max(0, st.remaining - 1);
              self._kiSave();
              self._renderKi();
            }
          });
        }).then(function (res) {
          if (!res || token !== st.token || res.code === 'cancelled') return;
          self._kiStopLoader();
          if (res.ok) {
            var r = {
              id: res.jobId, previewUrl: res.previewUrl, printUrl: res.printUrl || '', original: original, orientation: orientation, at: Date.now(),
              input: input.url, crop: input.crop, view: input.view, photo: input.photo
            };
            st.results.push(r);
            st.selectedId = r.id;
            st.phase = 'done';
            if (self.state.format !== orientation && !st.formatChangedWhileGen) self.state.format = orientation;
            self._kiSave();
            self._render();
            if (res.printPending && client.mode === 'http') self._kiWatchPrint(client, r);
            return;
          }
          if (res.quota) self._kiQuota(res.quota);
          if (res.started && K.refundsQuota(res.code)) {
            st.remaining = Math.min(st.limit, st.remaining + 1); // Worker bucht Fehler und Zeitüberschreitung zurück
          }
          if (res.code === 'visit_limit') st.remaining = 0;
          // Nochmal möglich: zurück zum Ausschnitt (gleiches Foto), der Button startet erneut
          if (K.isRetryable(res.code) && st.remaining > 0 && input.crop && self.state.photo && self.state.photo.url === original) st.crop = true;
          self._kiSave();
          self._kiFail(res.code);
        }).catch(function (err) {
          if (token !== st.token) return;
          if (window.console) console.error('[MnZ KI]', err);
          self._kiStopLoader();
          // Netz-/Skriptfehler: wie die übrigen wiederholbaren Fehler zurück in den Ausschnitt
          if (st.remaining > 0 && input.crop && self.state.photo && self.state.photo.url === original) st.crop = true;
          self._kiSave();
          self._kiFail('provider_error');
        });
      }

      _kiQuota(q) {
        if (typeof q.limit === 'number') this.kiState.limit = q.limit;
        if (typeof q.remaining === 'number') this.kiState.remaining = q.remaining;
      }

      _kiFail(code) {
        var st = this.kiState;
        st.phase = 'error';
        st.error = code;
        this._render();
      }

      // Druckdatei (Upscale) im Hintergrund nachziehen, danach _Print-URL aktualisieren
      _kiWatchPrint(client, r) {
        var self = this;
        var tries = 0;
        var tick = function () {
          if (++tries > 40 || !self.isConnected) return;
          setTimeout(function () {
            client.status(r.id).then(function (st) {
              var p = st.print || {};
              if (p.status === 'done' && p.url) {
                r.printUrl = p.url;
                self._kiSave();
                self._writeProperties();
              } else if (p.status === 'pending' || p.status === 'running') {
                tick();
              }
            }, tick);
          }, 5000);
        };
        tick();
      }

      _kiSelect(id) {
        var r = this._kiFind(id);
        if (!r) return;
        this.kiState.selectedId = id;
        this.kiState.view = 'after';
        this.kiState.crop = false;
        if (this.kiState.phase !== 'generating') {
          this.kiState.phase = 'done';
          this.kiState.error = null;
        }
        if (this.state.format !== r.orientation) this.state.format = r.orientation;
        if (!this.state.photo || this.state.photo.url !== r.original) {
          if (!this.state.busy) this._kiRestorePhoto(r);
        }
        this._kiSave();
        this._render();
      }

      // Format gewechselt: passendes Bild aus dem Verlauf nehmen, sonst Hinweis + Button (kein stiller Verbrauch)
      _kiAfterFormatChange() {
        var st = this.kiState;
        if (this._kiSelected()) return;
        for (var i = st.results.length - 1; i >= 0; i--) {
          var r = st.results[i];
          if (r.orientation === this.state.format && (!this.state.photo || r.original === this.state.photo.url)) {
            st.selectedId = r.id;
            this._kiSave();
            break;
          }
        }
        this._render();
      }

      _kiStartLoader() {
        var self = this;
        this._kiStopLoader();
        var t0 = Date.now();
        var est = Math.max(8, Math.min(40, this.ki.endpoint === 'mock' ? (this.ki.mockDelaySec || 20) : 20)) * 1000;
        var texts = this.kiState.waitTexts;
        var n = 0;
        if (this.kiEl.wait && texts.length) this.kiEl.wait.textContent = texts[0];
        if (this.kiEl.bar) this.kiEl.bar.style.width = '0%';
        this._kiTimer = setInterval(function () {
          var t = Date.now() - t0;
          // Fortschritt nähert sich 95 %, bleibt ehrlich ohne feste Zusage
          var pct = Math.min(95, Math.round(95 * (1 - Math.exp(-t / (est * 0.6)))));
          if (self.kiEl.bar) self.kiEl.bar.style.width = pct + '%';
          var next = Math.floor(t / 4500) % Math.max(1, texts.length);
          if (texts.length && next !== n && self.kiEl.wait) {
            n = next;
            self.kiEl.wait.textContent = texts[n];
          }
        }, 250);
      }

      _kiStopLoader() {
        if (this._kiTimer) clearInterval(this._kiTimer);
        this._kiTimer = null;
      }

      disconnectedCallback() {
        this._kiStopLoader();
        if (this.kiPreview) this.kiPreview.destroy();
        super.disconnectedCallback();
      }

      /* ---------- Kauf-Button ---------- */
      _ctaMode() {
        var base = Core.ctaMode({ variant: this.variant, busy: this.state.busy, hasPhoto: true });
        if (base === 'unavailable' || base === 'soldout' || base === 'uploading') return base;
        var st = this.kiState;
        if (!st) return 'upload';
        if (st.phase === 'generating') return 'generating';
        // R7: Ausschnitt offen = Kauf-Button erstellt (wie der große Button), nicht das alte Bild in den Warenkorb
        if (st.crop && this.state.photo && this.state.photo.url && st.remaining > 0) return 'generate';
        if (this._kiSelected()) return 'add';
        if (!this.state.photo || !this.state.photo.url) return 'upload';
        // Limits und Tages-/Monatsdeckel: kein neuer Versuch möglich (auch nicht mit anderem Foto)
        if (st.remaining <= 0 || ['visit_limit', 'ip_limit', 'budget', 'daily_images', 'month_budget'].indexOf(st.error) !== -1) return 'nogen';
        // Foto abgelehnt oder Prüfung fehlgeschlagen: neues Foto statt gleicher Versuch
        if (st.phase === 'error' && !K.isRetryable(st.error)) return 'upload';
        return 'generate';
      }

      _ctaLabel(mode) {
        if (mode === 'generating') return this.ks.ctaGenerating;
        // Tages-/Monatsdeckel: "Bild erstellen" würde etwas versprechen, das gerade nicht geht
        if (mode === 'nogen' && this.kiState && ['budget', 'daily_images', 'month_budget'].indexOf(this.kiState.error) !== -1) return this.ks.ctaPaused || this.ks.ctaGenerate;
        if (mode === 'generate') return this.ks.create || this.ks.ctaGenerate;
        if (mode === 'nogen') return this.ks.ctaGenerate;
        return super._ctaLabel(mode);
      }

      // Wie in mnz-buybox.js, nur "generate" ist zusätzlich klickbar. Komplett ersetzt statt nachkorrigiert:
      // der MutationObserver am Button ruft _renderCta bei jeder Änderung erneut auf (sonst Endlosschleife).
      _renderCta() {
        if (!this.cta) return;
        if (!this._themeOwnsCta()) {
          var mode = this._ctaMode();
          // Erstellen kostet nichts: im Erstellen-Schritt kein Preis am Button
          var price = this.variant && mode !== 'generate' && mode !== 'generating' ? Core.formatMoney(this.variant.price, this.cfg.moneyFormat) : '';
          var label = this._ctaLabel(mode);
          var key = mode + '|' + label + '|' + price;
          var disabled = !(mode === 'upload' || mode === 'add' || mode === 'generate');
          if (this.cta.getAttribute('data-mnz-key') !== key || !this.cta.querySelector('.mnz-cta__label')) {
            this.cta.setAttribute('data-mnz-key', key);
            this.cta.innerHTML = '';
            var iconHtml = this._ctaIcons ? this._ctaIcons[mode === 'upload' ? 'upload' : (mode === 'add' ? 'add' : '')] : '';
            if (iconHtml) {
              var ic = document.createElement('span');
              ic.className = 'mnz-cta__icon';
              ic.setAttribute('aria-hidden', 'true');
              ic.innerHTML = iconHtml;
              this.cta.appendChild(ic);
            }
            var l = document.createElement('span');
            l.className = 'mnz-cta__label';
            l.textContent = label;
            this.cta.appendChild(l);
            if (price) {
              var sep = document.createElement('span');
              sep.className = 'mnz-cta__sep';
              sep.setAttribute('aria-hidden', 'true');
              sep.textContent = '|';
              var p = document.createElement('span');
              p.className = 'mnz-cta__price';
              p.textContent = price;
              this.cta.appendChild(sep);
              this.cta.appendChild(p);
            }
          }
          if (this.cta.disabled !== disabled) this.cta.disabled = disabled;
          var soldout = mode === 'soldout' || mode === 'unavailable';
          if (this.cta.classList.contains('button--sold-out') !== soldout) this.cta.classList.toggle('button--sold-out', soldout);
          if (this.cta.getAttribute('data-mode') !== mode) this.cta.setAttribute('data-mode', mode);
        }
        this._mirrorSticky();
      }

      /* ---------- Eigenschaften ---------- */
      _writeProperties() {
        if (!this.kiState) return;
        var r = this._kiSelected();
        setProp(this.statusInput, r ? this.statusValue : '');
        setProp(this.styleInput, r ? (this.ki.styleName || '') : '');
        setProp(this.photoInput, r ? (r.printUrl || r.previewUrl) : '');
        setProp(this.originalInput, r ? r.original : '');
        setProp(this.jobInput, r ? r.id : '');
        setProp(this.cropInput, r && r.crop ? JSON.stringify(r.crop) : '');
        this.formatInput.value = this._kiFormatLabel(r ? r.orientation : this.state.format);
      }

      /* ---------- Darstellung ---------- */
      _render() {
        super._render();
        this._renderKi();
      }

      _renderKi() {
        var el = this.kiEl;
        var st = this.kiState;
        if (!el || !st || !el.root) return;
        var ks = this.ks;
        var sel = this._kiSelected();
        var photo = this.state.photo;
        var phase = st.phase;
        var generating = phase === 'generating';
        var cropping = !!(st.crop && photo && photo.url && !generating && !this.state.busy);
        el.root.setAttribute('data-state', cropping ? 'crop' : phase);

        el.idle.hidden = !!(photo || st.results.length || generating || this.state.busy);

        // R7: Ausschnitt wählen (Editor + Button), Kontingent darunter
        if (el.crop) {
          el.crop.hidden = !cropping;
          if (this.editor) this.editor.root.hidden = !cropping || !this.editor.photo;
          if (el.create) el.create.disabled = !cropping || st.remaining <= 0;
          if (el.cropQuota) el.cropQuota.textContent = K.fill(ks.quota, { rest: st.remaining, limit: st.limit });
          if (el.cropBack) el.cropBack.hidden = !(cropping && this._kiFind(st.selectedId));
          for (var fb = 0; fb < el.fmt.length; fb++) el.fmt[fb].setAttribute('aria-pressed', el.fmt[fb].getAttribute('data-mnz-ki-fmt') === this.state.format ? 'true' : 'false');
        }

        // Bühne: Ladeanimation über dem Vorher-Foto (R7: dem Ausschnitt) oder Ergebnis mit Vorher/Nachher
        var shown = generating || cropping ? null : sel;
        var showStage = generating || !!shown;
        el.stage.hidden = !showStage;
        var fmt = generating ? st.genFormat : (shown ? shown.orientation : this.state.format);
        el.frame.setAttribute('data-format', fmt === 'landscape' ? 'landscape' : 'portrait');
        var beforeSrc = '';
        if (generating && st.genInput && st.genInput !== (photo && photo.url)) beforeSrc = K.resultSrc(st.genInput);
        else if (generating && photo) beforeSrc = K.appendTransform(photo.url, 'c_fill,ar_' + (fmt === 'landscape' ? '5:4' : '4:5') + ',g_auto,w_900,f_auto,q_auto');
        else if (shown && shown.input && shown.crop) beforeSrc = K.resultSrc(shown.input);
        else if (shown) beforeSrc = K.appendTransform(shown.original, 'c_fill,ar_' + (fmt === 'landscape' ? '5:4' : '4:5') + ',g_auto,w_900,f_auto,q_auto');
        if (beforeSrc && el.before.getAttribute('src') !== beforeSrc) el.before.src = beforeSrc;
        var afterSrc = shown ? K.resultSrc(shown.previewUrl) : '';
        if (afterSrc && el.after.getAttribute('src') !== afterSrc) el.after.src = afterSrc;
        var view = generating ? 'before' : st.view;
        el.frame.setAttribute('data-view', view);
        el.before.hidden = !beforeSrc || view !== 'before';
        el.after.hidden = !afterSrc || view !== 'after';
        el.loader.hidden = !generating;
        el.frame.classList.toggle('is-loading', generating);
        el.toggle.hidden = !shown;
        el.badge.hidden = !shown || view !== 'after';
        el.note.hidden = !shown;
        if (this.kiPreview) this.kiPreview.setResult(shown);
        var vb = this.querySelectorAll('[data-mnz-ki-view]');
        for (var i = 0; i < vb.length; i++) vb[i].setAttribute('aria-pressed', vb[i].getAttribute('data-mnz-ki-view') === view ? 'true' : 'false');

        // Fehler
        var showErr = phase === 'error' && !!st.error;
        el.error.hidden = !showErr;
        if (showErr) {
          el.errorText.textContent = K.fill(ks[K.errorKey(st.error)] || ks.errGeneric || '', { limit: st.limit });
          // Im Ausschnitt startet der große Button erneut, kein zweiter Link
          el.retry.hidden = cropping || !(K.isRetryable(st.error) && photo && st.remaining > 0);
        }
        // Fehler im Ausschnitt über dem Editor, sonst unter dem Bild
        if (el.crop) {
          if (cropping) {
            if (el.error.nextElementSibling !== el.crop) el.crop.parentNode.insertBefore(el.error, el.crop);
          } else if (el.stage.nextElementSibling !== el.error) {
            el.stage.parentNode.insertBefore(el.error, el.stage.nextSibling);
          }
        }

        // Format passt nicht zum gewählten Bild
        var mismatch = !generating && !cropping && !sel && st.results.length > 0 && !showErr;
        el.mismatch.hidden = !mismatch;
        if (mismatch) el.mismatchText.textContent = K.fill(ks.formatMismatch, { format: this._kiFormatLabel(this.state.format) });

        // Verlauf (ab 2 Bildern)
        var list = st.results;
        el.history.hidden = list.length < 2;
        if (list.length >= 2) {
          var key = list.map(function (r) { return r.id; }).join(',') + '|' + (sel ? sel.id : '') + '|' + (generating ? 1 : 0);
          if (el.historyList.getAttribute('data-key') !== key) {
            el.historyList.setAttribute('data-key', key);
            el.historyList.innerHTML = '';
            for (var h = 0; h < list.length; h++) {
              var r = list[h];
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'mnz-ki__pick' + (r.orientation === 'landscape' ? ' is-landscape' : '');
              b.setAttribute('role', 'radio');
              b.setAttribute('data-mnz-ki-pick', r.id);
              var on = !!sel && sel.id === r.id;
              b.setAttribute('aria-checked', on ? 'true' : 'false');
              b.setAttribute('aria-label', K.fill(ks.historyItem, { n: h + 1 }) + ', ' + this._kiFormatLabel(r.orientation));
              b.disabled = generating;
              var img = document.createElement('img');
              img.src = K.thumb(r.previewUrl, 160);
              img.alt = '';
              img.width = 64;
              img.height = 80;
              img.loading = 'lazy';
              b.appendChild(img);
              el.historyList.appendChild(b);
            }
          }
        }

        // Neues Bild + Kontingent
        var canNew = !!photo && !generating && !this.state.busy;
        el.actions.hidden = !(photo || st.results.length) || generating || cropping;
        // Abgelehntes Foto nicht nochmal schicken: dann nur "Foto ändern"
        el.newBtn.hidden = !photo || (phase === 'error' && !K.isRetryable(st.error) && st.error !== 'visit_limit' && st.error !== 'ip_limit');
        el.newBtn.disabled = !canNew || st.remaining <= 0;
        el.newBtn.textContent = mismatch ? K.fill(ks.formatCreate, { format: this._kiFormatLabel(this.state.format) }) : (this._kiNewLabel || (this._kiNewLabel = el.newBtn.textContent));
        el.quota.textContent = st.remaining > 0 ? K.fill(ks.quota, { rest: st.remaining, limit: st.limit }) : K.fill(ks.quotaEmpty, { limit: st.limit });
        el.quota.classList.toggle('is-empty', st.remaining <= 0);
      }
    }

    window.customElements.define('mnz-ki-buybox', MnzKiBuybox);
  }

  var tsPromise = null;
  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (!tsPromise) {
      tsPromise = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        s.async = true;
        s.onload = function () { window.turnstile ? resolve(window.turnstile) : reject(new Error('turnstile')); };
        s.onerror = function () { reject(new Error('turnstile')); };
        document.head.appendChild(s);
      });
    }
    return tsPromise;
  }

  if (window.customElements.get('mnz-buybox')) {
    define();
  } else {
    window.customElements.whenDefined('mnz-buybox').then(define);
  }
})(typeof window !== 'undefined' ? window : globalThis);
